module.exports = __webpack_public_path__ + "static/media/ic_sal.3b250192.png";